import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/blast-hero/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/blast-hero',
  name: 'activity_blast_hero',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '爆破英雄',
  },
}

export default [indexRoute]
